import React from 'react';

import styles from './EquipmentSpecifications.module.scss';
import api from '../../../helpers/api';
import { $t } from '../../../helpers/translator';
import Loader from '../../miscellaneous/Loader/Loader';
import Modal from '../../miscellaneous/Modal/Modal';

class EquipmentSpecifications extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            loading: false,

            modalContent: null //flag for modal
        };
    }

    async componentDidMount() {
        await this.init();
    }

    async init() {
        this.setState({ loading: true }, async () => {
            try {
                // let res = await api.getServiceMyEquipment();
                let res = await api.get('general/equipment');
                if (res && res.data) {
                    this.setState({ equipment: res.data.data });
                }
            } catch (e) {
                console.error('err fetching videos');
            } finally {
                this.setState({ loading: false });
            }
        });
    }

    setModalContent(data) {
        this.setState({ modalContent: data });
    }

    renderModalContent() {
        let data = this.state.modalContent;
        let extension = data.specifications.substring(data.specifications.length - 3);

        let content;
        if (extension === 'pdf') {
            content =
                <div className={`${styles['pdf-container']}`}>
                    <object data={data.specifications} type="application/pdf" width="100%" height="100%">
                        <p>Could not display PDF. <a href={data.specifications}>Download</a></p>
                    </object>
                </div>;
        } else {
            content =
                <div>
                    <div className={`${styles['img-container']}`}>
                        <img src={data.specifications} alt={data.name} style={{ width: '100%' }}/>
                    </div>
                </div>;
        }

        return (
            <div className={`${styles[(extension === 'pdf' ? 'modal-content-container' : '')]}`}>
                {content}
            </div>
        );
    }

    closeModals() {
        this.setState({ modalContent: null });
    }

    renderLink(product) {
        return (
            <div>
                {
                    product.specifications ?
                        <div className={`${styles['link-container']}`}>
                            <span className={`${styles['link']}`} onClick={() => this.setModalContent(product)}>
                                {product.name}
                            </span>
                            <span className={`${styles['learn-more-text']}`}>
                                {$t('global.service.learnMore')}
                            </span>
                        </div>
                        :
                        <span>
                            {product.name}
                        </span>
                }
            </div>
        );
    }

    render() {
        return (
            <div className={`alma-box ${styles['box']}`}>

                {this.state.modalContent ?
                    <Modal content={this.renderModalContent()}
                           onClose={this.closeModals.bind(this)}
                           visible={!!this.state.modalContent}/>
                    : null
                }

                <div className={'alma-box-header'}>
                    <span><h3>{$t('global.service.myEquipment')}</h3></span>
                </div>
                {this.state.loading ?
                    <Loader/>
                    :
                    null
                }

                {this.state.equipment && this.state.equipment.length ?
                    <div className={'alma-box-content'}>
                        <div>
                            {this.state.equipment.map((v, k) => (
                                <span key={k}>
                                    {
                                        this.renderLink(v)
                                    }
                                </span>
                            ))}
                        </div>
                    </div>
                    :
                    <div style={{
                        textAlign: 'center',
                        paddingTop: '10px'
                    }}>{$t('global.service.noEquipment')}</div>
                }
            </div>
        );
    }
}

export default EquipmentSpecifications;
